module.exports = __webpack_public_path__ + "img/d.7f3f6faf.jpg";